module.exports = __webpack_public_path__ + "img/wechat.4672c0bd.png";